import React from 'react';


export default class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    let val = this.props.value || false;
    this.state = {
      value: val
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidUpdate(prevProps, prevState){
    if ((prevProps.value !== this.props.value)) {
      this.setState({
        value: this.props.value
      });
    }
  }
  handleChange(value) {
    if(this.props.callback != null){
      this.props.callback({
        field: this.props.name,
        value: value,
      })
    }
  }
  toggleStatus = () => {
    let newVal = !this.state.value;
    console.log(newVal)
    this.handleChange(newVal);
  }
  render() {
    let val = this.state.value;
    return (
          <div className="checkbox-cnt">
            <div className={ (this.state.value == true) ? 'checkbox a checked '+this.state.value : 'a checkbox' } onClick={this.toggleStatus}>
              {(this.state.value==true) ?
                (
                  <span className="icon">square</span>
                )
                :
                (
                  <span className="icon">square check</span>
                )
              }
              <span className="ms-2">{this.props.label || this.props.name}</span>
            </div>
          </div>
    );
  }
}
